import { render, staticRenderFns } from "./ErrorSetting.vue?vue&type=template&id=7261f80c&scoped=true"
import script from "./ErrorSetting.vue?vue&type=script&lang=ts"
export * from "./ErrorSetting.vue?vue&type=script&lang=ts"
import style0 from "./ErrorSetting.vue?vue&type=style&index=0&id=7261f80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261f80c",
  null
  
)

export default component.exports